export let firebaseAppCredentials = JSON.parse(
  process.env.REACT_APP_FIREBASE_APPLICATION_CREDENTIALS as string
);
